import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";
import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import {useNavigate} from "react-router-dom";
import {css} from "@emotion/css";

const GalleryDetail = () => {
    const navigate = useNavigate()
    return (
        <>
            <Helmet>
                <title>{RouteInfo.GalleryDetail.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <ButtonDivisionSection>
                        <RaikoBreadcrumb
                            className={css`flex-grow: 1`}
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    "چند رسانه ای",
                                    "",
                                ),
                                raikoBreadCrumbItemGenerator(
                                    RouteInfo.GalleryList.name,
                                    RouteInfo.GalleryList.globalUrl,
                                ),raikoBreadCrumbItemGenerator(
                                    RouteInfo.GalleryDetail.name,
                                    ""
                                ),
                            ]
                            }/>
                        <ButtonSecondaryRaiko
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(RouteInfo.GalleryList.globalUrl)
                            }}
                        />
                    </ButtonDivisionSection>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}
export default GalleryDetail;